// Compatibility route for legacy /sports/nba navigation.
// The old dedicated NBA page must not bypass the canonical Sports resolver.
import { renderSearchResults } from "./SearchResults";

export function renderNBARoute(): void {
  const query = "NBA";
  const canonicalSearchUrl = `/search?q=${encodeURIComponent(query)}`;

  if (window.location.pathname.toLowerCase() === "/sports/nba") {
    window.history.replaceState({}, "", canonicalSearchUrl);
  }

  renderSearchResults(query);
}
